define('models/InstagramCategoryCollection',['underscore', 'ObjectCollection', 'models/InstagramCategoryModel'], function (_, ObjectCollection, InstagramCategoryModel) {
    var InstagramCategoryCollectionPrototype = {

        name: 'InstagramCategoryCollection',
        route: 'apiInstagramCategoryCollection',
        model: InstagramCategoryModel,
        initialize: function () {
            ObjectCollection.prototype.initialize.apply(this, arguments);
        }
    };

    return ObjectCollection.extend(InstagramCategoryCollectionPrototype);
});
